<template>
  <v-container>
    <v-card>
      <v-card-title>
        <h2>Personal information:</h2>
      </v-card-title>
      <v-card-text>
        <p>
          <b>User name: </b>
          {{getCurrentUserDetails.userName}}
        </p>
        <p>
          <b>Email: </b>
          {{getCurrentUserDetails.email}}
        </p>
        <v-divider light></v-divider>
        <h4>Scopes: </h4>
        <v-chip v-for="scope in userScopes" :key="`scope-${scope}`">
          {{ scope }}
        </v-chip>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'personal-information',
  computed: {
    ...mapGetters([
      'userScopes',
      'getCurrentUserDetails'
    ])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PersonalInformation/index.vue